import { useState } from 'react';

import eyeClose from '../../../assets/icons/General/eye-close.png';
import eyeOpen from '../../../assets/icons/General/eye-open.png';

interface InputProps {
  label?: string;
  name?: string;
  id?: string;
  placeholder?: string;
  value?: string;
  type?: string;
  hint?: string;
  autoComplete?: string;
  className?: string;
  inputClass?: string;
  disabled?: boolean;
  error?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

function Input({
  label,
  name,
  id,
  placeholder,
  value,
  type,
  hint,
  autoComplete,
  className,
  inputClass,
  disabled,
  error,
  onChange,
  ...rest
}: InputProps) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <div className={`relative ${className}`}>
      {label && (
        <label
          htmlFor={`${name}`}
          className={`text-black-700 mb-1 block text-sm leading-5 font-medium ${
            disabled && 'cursor-not-allowed'
          }`}
        >
          {label}
        </label>
      )}
      <div className="relative">
        <input
          id={id ? `${id}` : `input-${label}`}
          name={name}
          type={
            type
              ? type === 'password' && !showPassword
                ? 'password'
                : 'text'
              : 'text'
          }
          value={value}
          placeholder={placeholder}
          autoComplete={autoComplete}
          className={`border-grey-100 placeholder:text-grey-500 w-full rounded-xl border px-3 py-2 text-base outline-hidden transition-all duration-150 placeholder:font-normal ${
            !disabled &&
            'hover:border-grey-300 focus:border-primary-300 focus:shadow-[0px_0px_0px_4px_#D1E9FF]'
          } ${
            error &&
            'border-red-600 hover:border-red-300 focus:border-red-300 focus:shadow-[0px_0px_0px_4px_#FEE4E2]'
          } ${
            disabled &&
            'text-grey-500 bg-grey-25 placeholder:text-grey-500 cursor-not-allowed'
          } ${inputClass}`}
          onChange={onChange}
          {...rest}
          disabled={disabled}
        />
        {type === 'password' && (
          <div
            className="absolute right-[7.44px] bottom-[8px] cursor-pointer p-2"
            onClick={() => setShowPassword(!showPassword)}
          >
            <img
              src={showPassword ? eyeOpen : eyeClose}
              className="w-[13.13px]"
              alt=""
            />
          </div>
        )}
      </div>
      {hint && (
        <span className="text-black-600 mt-[6px] block text-xs leading-5 font-normal">
          {hint}
        </span>
      )}
      {error && <div className="text-redd-600 mt-[6px] text-sm">{error}</div>}
    </div>
  );
}

export default Input;
